import { get, some } from 'lodash';

import { AppState } from '../root.reducer';

export const createLoadingSelector = (actions: string[]) => (state: AppState) => {
  // returns true only when all actions is not loading
  return some(actions, action => get(state, `loading.${action}`));
};
